<template>
  <button
    :disabled="loading"
    type="submit"
    @click="buttonClicked"
    :class="[{'bg-white hover:bg-white shadow-none' : loading}]"
    class="primary-button"
  >
    <loader-icon v-if="this.loading" class="h-5 w-5 text-primary-500"></loader-icon>
    <slot v-else></slot>
  </button>
</template>

<script>
export default {
  props: {
    loading: Boolean,
  },

  methods: {
    buttonClicked() {
      this.$emit("buttonClicked");
    },
  },
};
</script>